export const CLINIC = {
  name: "Yin Motion",
  tagline: "Saúde e Bem-Estar",
  foundedYear: 2011,
  yearsOfExperience: 15,
  phoneRaw: "+351281327218",
  phoneDisplay: "+351 281 327 218",
  whatsappRaw: "351964112387",
  whatsappDisplay: "+351 964 112 387",
  email: "momentosyinmotion@gmail.com",
  addressLine: "Rua Dom Marcelino Franco n.º 49, 8800-347 Tavira",
  googleRating: 4.9,
  googleReviews: 90,
  hours: [
    { day: "Segunda – Sexta", time: "09:00 – 19:00" },
    { day: "Sábado e Domingo", time: "Encerrado" },
  ],
  mapsEmbed:
    "https://www.google.com/maps?q=Rua+Dom+Marcelino+Franco+49%2C+8800-347+Tavira%2C+Portugal&output=embed",
  socials: {
    facebook: "https://www.facebook.com/share/1LQKQKdVnA/",
    instagram: "https://www.instagram.com/yin_motion?igsh=MXRqOTI2NHFjczN3dA==",
  },
};

export const WHATSAPP_URL = `https://wa.me/${CLINIC.whatsappRaw}?text=${encodeURIComponent(
  "Olá, gostaria de marcar uma consulta na Yin Motion."
)}`;

export const SERVICE_CATEGORIES = [
  {
    id: "reabilitacao",
    eyebrow: "01 — Reabilitação",
    title: "Reabilitação e Fisioterapia",
    image:
      "https://images.pexels.com/photos/20860586/pexels-photo-20860586.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    description:
      "Recuperação funcional com avaliação completa, planos individuais e equipamentos avançados.",
    items: [
      "Fisioterapia personalizada com base científica",
      "Avaliação completa e acompanhamento individual",
      "Equipamentos avançados e ginásio de reabilitação",
    ],
  },
  {
    id: "movimento",
    eyebrow: "02 — Movimento",
    title: "Movimento e Performance",
    image:
      "https://images.unsplash.com/photo-1747239685045-fcbcf98985db?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxwaWxhdGVzJTIwcmVmb3JtZXJ8ZW58MHx8fHwxNzc2NDU5NDA5fDA&ixlib=rb-4.1.0&q=85",
    description:
      "Técnicas integradas para prevenção de lesões, performance e qualidade de vida.",
    items: [
      "Pilates Clínico (equipamentos e tapete)",
      "Gyrotonic® — movimento tridimensional",
      "Power Plate — estimulação neuromuscular",
      "Treino clínico personalizado",
    ],
  },
  {
    id: "saude-integrada",
    eyebrow: "03 — Saúde Integrada",
    title: "Saúde Integrada",
    image:
      "https://images.unsplash.com/photo-1757689314932-bec6e9c39e51?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxzcGElMjBtYXNzYWdlJTIwdGhlcmFweXxlbnwwfHx8fDE3NzY0NTk0MTB8MA&ixlib=rb-4.1.0&q=85",
    description:
      "Uma abordagem multidisciplinar que promove equilíbrio físico e emocional.",
    items: [
      "Terapia da Fala",
      "Psicologia",
      "Medicina Tradicional Chinesa",
      "Osteopatia",
    ],
  },
];

export const SERVICE_OPTIONS = [
  "Fisioterapia",
  "Pilates Clínico",
  "Gyrotonic®",
  "Power Plate",
  "Treino Clínico",
  "Osteopatia",
  "Terapia da Fala",
  "Psicologia",
  "Medicina Tradicional Chinesa",
  "Outro / Não sei ainda",
];

export const DIFFERENTIATORS = [
  {
    title: "Atendimento individual",
    description: "Um paciente de cada vez, para cuidado focado e sem interrupções.",
  },
  {
    title: "Planos personalizados",
    description: "Cada plano é desenhado a partir de uma avaliação aprofundada.",
  },
  {
    title: "Base científica",
    description: "Intervenções apoiadas em evidência e formação contínua.",
  },
  {
    title: "Abordagem integrada",
    description: "Equipas multidisciplinares que olham para o todo, não apenas o sintoma.",
  },
];

export const REASONS = [
  "Mais de 15 anos de experiência em Tavira",
  "Abordagem clínica baseada em evidência científica",
  "Equipa altamente qualificada e multidisciplinar",
  "Programas personalizados de reabilitação e treino",
  "Ambiente profissional, acolhedor e seguro",
];

export const TESTIMONIALS = [
  {
    quote: "Excelente acompanhamento e grande profissionalismo.",
    author: "Ana C.",
    role: "Paciente desde 2022",
  },
  {
    quote: "O Pilates clínico ajudou muito nas minhas dores lombares.",
    author: "João P.",
    role: "Pilates Clínico",
  },
  {
    quote: "Equipa muito competente e atenciosa.",
    author: "Maria S.",
    role: "Fisioterapia",
  },
];

export const NAV_LINKS = [
  { id: "inicio", label: "Início" },
  { id: "quem-somos", label: "Quem Somos" },
  { id: "servicos", label: "Serviços" },
  { id: "testemunhos", label: "Testemunhos" },
  { id: "contacto", label: "Contacto" },
];
